import API_LOCAL from "./api-local";
import API_PROD from "./api-prod";
const hostname =
  typeof window !== "undefined" ? window.location.hostname : null;
const port = typeof window !== "undefined" ? window.location.port : null;
let isLocalApi = port >= 3000;

export const API = (hostname === "localhost" && isLocalApi)
  ? API_LOCAL : API_PROD;